import { Response, httpDelete, httpPost } from "@config/http";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { trackPromise } from "react-promise-tracker";

const { REACT_APP_BASE_URL } = process.env;

const initialState = {};

const deleteUser = createAsyncThunk("user/delete user", async () => {
  let results: Response | null;
  try {
    results = await trackPromise(
      httpDelete(`${REACT_APP_BASE_URL}/api/v1/users`, true)
    );
    return Promise.resolve(results?.data);
  } catch (error) {
    return Promise.reject(error);
  }
});

const accountSlice = createSlice({
  name: "account",
  initialState: initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {},
});

export const accountReducer = accountSlice.reducer;

export const accountActions = {
  ...accountSlice.actions,
  deleteUser,
};
